<template>
  <SplitViewTemplate
    :screenConfig="data"
    :backButtonRoute="'/settings/intake'"
    :dataModel="formModel"
    :formConfig="setFormConfig"
    :setLoading="setLoading"
    :validationSummary="validationSummary"
    :ref="'average-throughput'"
    :defaultUserSettings="false"
  />
</template>
<script>
import { FeatureStorage } from "@/_services/storage";
import SplitViewTemplate from "../../../templates/split-view";
import RouteMixin from "@/_mixins/route.mixin";
import { AverageThroughputService } from "../../../_services/api/settings/production/average-throughput.service";

export default {
  mixins: [RouteMixin],
  components: {
    SplitViewTemplate,
  },
  data() {
    return {
      setLoading: false,
      validationSummary: [],
      formModel: {
        DateEnd: null,
        DateStart: null,
        MeasurementUnit: null,
        ProcessCode: null,
        ProcessDescription: null,
        ProcessSearchText: null,
        RecordId: null,
        Status: "A",
        Inactive: "N",
        Throughput: null,
        ThroughputDisplayText: null,
        TimeUnit: null,
        ChangedBy: "",
        CreatedBy: "",
        DateChanged: "",
        DateCreated: "",
      },
      data: {
        title: "Average Throughput",
        pageRoute: "/average-throughput",
        saveEndPoint: "ProcessThroughput",
        updateEndPoint: "ProcessThroughput",
        updateKeyField: "RecordId",
        updateKeyFieldType: "Guid",
        recordEndPoint: "ProcessThroughputList",
        exportFileName: "Average Throughput",
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "ProcessThroughputList",
              filter: "",
              serverPaging: true,
              allowGrouping: false,
              postProcessCallback: this.postProcessCallback,
            },
            rowSelect: {
              view: this,
              page: "average-throughput",
              mode: "review",
              idMode: "Guid",
              idProperty: "RecordId",
              rowSelectCallBack: () => {
                this.beforeInit();
              },
            },
          },

          toolbar: {
            search: true,
            columnChooser: true,
            export: false,
            openFilter: true,
            expand: false,
            customButtons: [
              {
                icon: "plus",
                label: "Add New",
                route: "/average-throughput/create",
                clickAction: () => {
                  this.goToCreateIntakeSize();
                },
                buttonLocation: "left",
                // disabled: false,
                visible: FeatureStorage.checkPermission(
                  "AlmondcoIntakeSettings",
                  "create"
                ),
              },
            ],
          },
          columns: [
            {
              screenField: "Process",
              allowHiding: false,
              sortIndex: 0,
              sortOrder: "asc",
              gridDataField: "ProcessDescription",
              dataField: "ProcessDescription",
              filterIndex: 0,
              type: "Text",
              cellTemplateRecord: {
                primary: [
                  {
                    dataField: "ProcessDescription",
                  },
                ],
                secondary: [
                  {
                    dataField: "ProcessCode",
                  },
                ],
              },
              exportFields: [
                {
                  dataField: "ProcessCode",
                  label: "Process Code",
                },
                {
                  dataField: "ProcessDescription",
                  label: "Process Description",
                },
              ],
            },
            {
              screenField: "Date",
              dataField: "DateStart",
              filterDataField: "DateStart",
              label: "Start Date",
              filterLabel: "Start Date",
              filterIndex: 3,
            },
            {
              screenField: "Date",
              dataField: "DateEnd",
              filterDataField: "DateEnd",
              label: "End Date",
              filterLabel: "End Date",
              filterIndex: 4,
            },
            {
              dataField: "ThroughputDisplayText",
              label: "Throughput",
              alignment: "right",
              calculateSortValue: "Throughput",
              width: "200px",
            },
            {
              screenField: "Status",
              width: "auto",
              filterIndex: 0,
              fixed: false,
              filterDefaultValue: ["N"],
            },
            {
              dataField: "MeasurementUnit",
              label: "UM",
              visible: false,
              showInColumnChooser: true,
              width: "100px",
            },
            {
              dataField: "TimeUnit",
              label: "Time Unit",
              visible: false,
              showInColumnChooser: true,
              width: "100px",
            },
          ],
          valueChangedEventListners: [],
        },
      },
      updatedDefaultRecordId: undefined,
      recordEditable: true,
    };
  },
  computed: {
    setFormConfig() {
      const form = {
        headerToolbar: {
          closeSplit: true,
          save: this.setSaveOption,
          audit: true,
          auditItems: [
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  dataField: "FormattedDateCreated",
                  label: { text: "Created By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    disabled: true,
                  },
                },
                {
                  dataField: "FormattedDateChanged",
                  label: { text: "Changed By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    disabled: true,
                  },
                },
              ],
            },
          ],
          toolbarFormItems: [
            {
              screenField: "Inactive",
              editorType: "dxSwitch",
              dataField: "Inactive",
              editorOptions: {
                readOnly: false,
              },
              cssClass: "toolbar-customer-label",
            },
          ],
          toolbarFormLocation: "after",
          editCallBack: () => {
            this.beforeInit();
          },
        },
        formItems: [
          {
            itemType: "group",
            caption: "",
            colCount: 1,
            items: [
              {
                dataField: "ProcessCode",
                label: { text: "Process", location: "left" },
                editorType: "dxSelectBox",
                required: true,
                editorOptions: {
                  dataSource: AverageThroughputService.dataSourceConfig(
                    "api/Process",
                    {
                      select: ["Code", "Description"],
                      filter: ["Inactive", "=", "N"],
                    }
                  ),
                  valueExpr: "Code",
                  itemTemplate: (data) => {
                    return ` <div class="custom-auto-complete" id="${data.Code}" >
                            <span class="auto-complete-primary">
                              ${data.Code}
                            </span>
                            <span class="record-secondary gc-grid-code">
                              ${data.Description}
                            </span>
                          </div>`;
                  },
                  searchEnabled: true,
                  showClearButton: true,
                  placeholder: "Select Process",
                  tabIndex: 1,
                  displayExpr: (item) => {
                    if (item) return item.Code + " - " + item.Description;
                    else return "";
                  },
                },
              },
              {
                itemType: "group",
                caption: "",
                colCount: 2,
                cssClass: "date-group",
                items: [
                  {
                    dataField: "DateStart",
                    label: { text: "Start Date" },
                    editorType: "dxDateBox",
                    required: true,
                    editorOptions: {
                      type: "date",
                      displayFormat: "dd MMM yyyy",
                      tabIndex: 2,
                    },
                  },
                  {
                    dataField: "DateEnd",
                    label: { text: "End Date" },
                    editorType: "dxDateBox",
                    required: true,
                    editorOptions: {
                      type: "date",
                      displayFormat: "dd MMM yyyy",
                      tabIndex: 3,
                      min: this.formModel.DateStart,
                    },
                  },
                ],
              },
              {
                itemType: "group",
                caption: "",
                colCount: 3,
                cssClass: "date-group",
                items: [
                  {
                    dataField: "Throughput",
                    label: { text: "Throughput" },
                    editorType: "dxNumberBox",
                    required: true,
                    dataType: "number",
                    editorOptions: {
                      min: 0,
                      tabIndex: 4,
                      format: "##,###,###,###,##0.0000",
                    },
                  },
                  {
                    dataField: "MeasurementUnit",
                    label: {
                      text: "UM",
                      location: "left",
                    },
                    gcLabel: "UM",
                    required: true,
                    gcType: "String",
                    editorType: "dxSelectBox",
                    editorOptions: {
                      dataSource: AverageThroughputService.dataSourceConfig(
                        "api/UnitOfMeasure",
                        {
                          select: ["Code", "Description"],
                          filter: ["Inactive", "=", false],
                          sort: [{ selector: "Description", asc: true }],
                        }
                      ),
                      itemTemplate: (data) => {
                        return ` <div class="custom-auto-complete" id="${data.Code}" >
                            <span class="auto-complete-primary">
                              ${data.Description}
                            </span>
                            <span class="auto-complete-secondary">
                              ${data.Code}
                            </span>
                          </div>`;
                      },
                      valueExpr: "Code",
                      displayExpr: "Code",
                      searchExpr: ["Code", "Description"],
                      searchMode: "contains",
                      tabIndex: 5,
                      searchEnabled: true,
                    },
                  },
                  {
                    dataField: "TimeUnit",
                    label: {
                      text: "Time Increment",
                      location: "left",
                    },
                    required: true,
                    gcType: "String",
                    editorType: "dxSelectBox",
                    editorOptions: {
                      dataSource: [
                        { key: "MIN", value: "Minute" },
                        { key: "HR", value: "Hour" },
                      ],
                      itemTemplate: (data) => {
                        return ` <div class="custom-auto-complete" id="${data.key}" >
                            <span class="auto-complete-primary">
                              ${data.value}
                            </span>
                          </div>`;
                      },
                      valueExpr: "key",
                      displayExpr: "value",
                      tabIndex: 6,
                      value: "HR",
                    },
                  },
                ],
              },
            ],
          },
        ],
        overWritePayload: this.overWritePayload,
      };

      return form;
    },
    setSaveOption() {
      return FeatureStorage.checkPermission(
        this.$route.meta.applicationFeatureCode,
        "create"
      );
    },
  },
  methods: {
    goToCreateIntakeSize() {
      this.$router
        .push({
          path: `/average-throughput/create`,
        })
        .then(() => {
          this.recordEditable = true;
        });
    },
    beforeInit() {
      this.recordEditable = true;
    },
    overWritePayload(payload) {
      payload.Status = payload.Inactive === "Y" ? "I" : "A";
      return payload;
    },
    postProcessCallback(data) {
      data.forEach((item) => {
        item.FriendlyStatus = item.Status === "A" ? "Active" : "Inactive";
      });
      return data;
    },
  },
  created() {
    this.beforeInit();
  },
};
</script>
